import {MemberFormType, MemberPhoneNumber} from "../api/member/Member";

export function getPhoneNumber(
    phoneNumber: MemberPhoneNumber,
    memberPhoneCarrierType?: MemberFormType[],
): string {
    return `${memberPhoneCarrierType?.find(carrierType => carrierType.id == phoneNumber.carrier)?.title}-${phoneNumber.number1}-${phoneNumber.number2}`
}